(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6248],{

/***/ 28442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isHostComponent; }
/* harmony export */ });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/***/ }),

/***/ 40778:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/codePromo",
      function () {
        return __webpack_require__(14575);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55757);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);









const Footer = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [isActive, setIsActive] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { t  } = (0,_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var _router_pathname_split_, _router_pathname;
        setIsActive((_router_pathname_split_ = router === null || router === void 0 ? void 0 : (_router_pathname = router.pathname) === null || _router_pathname === void 0 ? void 0 : _router_pathname.split("/")[1]) === null || _router_pathname_split_ === void 0 ? void 0 : _router_pathname_split_.trim());
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-[#241C28] md:px-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-[1366px] mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "lg:py-[150px] py-[80px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex lg:flex-row flex-col flex-wrap lg:justify-between lg:items-start items-center justify-center gap-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "lg:block hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/svg/logo-white.svg",
                                    alt: "FiDarri logo",
                                    width: 273,
                                    height: 153
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-10 text-white lg:items-start items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "font-bold text-lg tracking-wider capitalize",
                                        children: "FiDarri"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-5 tracking-wider text-base leading-5 lg:items-start items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/ConditionsGenerale",
                                                className: "ha:hover:text-secondary",
                                                children: t("termes et conditions")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/Politique",
                                                className: "ha:hover:text-secondary",
                                                children: t("politique de confidentialit\xe9")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-10 text-white lg:items-start items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "font-bold text-lg tracking-wider capitalize",
                                        children: t("\xe0 propos")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-5 tracking-wider text-base leading-5 lg:items-start items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/codePromo",
                                                className: "ha:hover:text-secondary",
                                                children: t("Code promos")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/AboutUs",
                                                className: "ha:hover:text-secondary",
                                                children: t("\xe0 propos de nous")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-10 text-white lg:items-start items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "font-bold text-lg tracking-wider capitalize",
                                        children: t("contact")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-5 tracking-wider text-base leading-5 lg:items-start items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: isActive === "recrutement" ? "/inscription" : "/register",
                                                className: "ha:hover:text-secondary",
                                                children: t("Rejoignez-nous")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "tel:0773456096",
                                                className: "ha:hover:text-secondary",
                                                children: "+213 (0) 773 45 60 96"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "mailto:contact@fidarri.com",
                                                className: "ha:hover:text-secondary",
                                                children: "contact@fidarri.com"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-10 text-white lg:items-start items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "font-bold text-lg tracking-wider capitalize",
                                        children: t("Besoin d'aide ?")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col gap-5 tracking-wider text-base leading-5 lg:items-start items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/help",
                                            className: "ha:hover:text-secondary",
                                            children: t("Centre d’aide")
                                        })
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "lg:hidden block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/svg/logo-white.svg",
                                    alt: "FiDarri Logo",
                                    width: 273,
                                    height: 153
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center lg:justify-end border-b border-[#C8C8C8]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-4 py-6 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/svg/facebook.svg",
                                alt: "facebook"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/svg/twitter.svg",
                                alt: "twitter"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/svg/insta.svg",
                                alt: "insta"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/svg/in.svg",
                                alt: "in"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "py-[46px] w-full ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full font-semibold justify-center items-center text-center text-xs text-white tracking-widest",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "max-w-[335px]",
                            children: "Designed and developed by Smartinia.dz all Rights Reserved to \xa9 FiDarri 2023"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 63096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Pagination = (param)=>{
    let { count , pagesize , setPage , page , showPages =3  } = param;
    // console.log("count", count);
    const pages = (currentPage, last)=>{
        var list = [];
        var Lastcell = null;
        for(var i = 1; i <= last; i++){
            if (i === 1 || currentPage + 1 === 1 && i <= showPages || i === last || currentPage + 1 === last && i >= last - (showPages - 1) || i === currentPage + 1 || !(i <= currentPage + 1 - Math.ceil(showPages / 2)) && i <= currentPage || !(i >= currentPage + 1 + Math.floor(showPages / 2) + 1) && i >= currentPage) {
                list.push(i);
                Lastcell = "".concat(i);
            } else {
                if (Lastcell !== "...") {
                    list.push("...");
                    Lastcell = "...";
                }
            }
        }
        return list === null || list === void 0 ? void 0 : list.map((item, index)=>item === "..." && list[index + 1] - list[index - 1] === 2 ? list[index - 1] + 1 : item);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center border border-[#D4D4D8] h-[40px] rounded-[10px] w-fit",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    if (page + 1 > 1) setPage(page - 1);
                },
                disabled: page > 0 ? false : true,
                className: " h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center \n        ".concat(page > 0 ? "flex" : "hidden", "\n        "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/svg/arrow-left-black.svg",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-full flex flex-row items-center justify-center",
                children: pages(page, Math.ceil(count / pagesize)).map((pageCell, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cell, {
                        setPage: setPage,
                        page: page,
                        number: pageCell
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    if (page + 1 < Math.ceil(count / pagesize)) setPage(page + 1);
                },
                disabled: page + 1 < Math.ceil(count / pagesize) ? false : true,
                className: " h-full w-[40px] border-l border-l-[#D4D4D8] flex items-center justify-center \n        ".concat(page + 1 < Math.ceil(count / pagesize) ? "flex" : "hidden", "\n        "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/svg/arrow-right-black.svg",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);
const Cell = (param)=>{
    let { setPage , page , number  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        disabled: number === "..." || page + 1 === number ? true : false,
        onClick: ()=>{
            setPage(number - 1);
        },
        className: "h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center".concat(page + 1 === number ? "h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center bg-secondary text-white" : number === "..." ? "h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center" : "h-full w-[40px] border-l border-l-[#D4D4D8] flex items-center justify-center", " "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: number
        })
    });
};


/***/ }),

/***/ 17522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Spinner = (param)=>{
    let { h , w  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "inline-block ".concat(h ? h : "h-4", " ").concat(w ? w : "w-4", " animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"),
        role: "status",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]",
            children: "Loading..."
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 27882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55678);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64213);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55757);



//toast


//hooks

const Layout = (props)=>{
    const { t  } = (0,_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    // console.log("props :", props);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: (props === null || props === void 0 ? void 0 : props.title) ? t(props === null || props === void 0 ? void 0 : props.title) + " - FiDarri" : "FiDarri"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "theme-color",
                        content: "#000000"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "fidarri,travaille,job,work,femme,fi,dar,darri,dz"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com",
                        crossOrigin: "true"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Sofia&display=swap",
                        rel: "stylesheet"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favico.ico"
                    })
                ]
            }),
            props.children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .ToastContainer */ .Ix, {
                position: "bottom-right"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 14575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ codePromo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hoc/Layout.jsx
var Layout = __webpack_require__(27882);
// EXTERNAL MODULE: ./components/Header.jsx + 4 modules
var Header = __webpack_require__(68571);
// EXTERNAL MODULE: ./components/Footer.jsx
var Footer = __webpack_require__(37127);
// EXTERNAL MODULE: ./graphql/services/index.js + 4 modules
var services = __webpack_require__(86778);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./hooks/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(55757);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./components/Spiner.jsx
var Spiner = __webpack_require__(17522);
// EXTERNAL MODULE: ./components/Pagination.jsx
var Pagination = __webpack_require__(63096);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./layouts/CodePromoLayout.jsx


//service

//mui

//hook

//next


// js

// Component


// Redux

const CodePromoLayout = ()=>{
    var _paginatedPromoCodes_nodes, _paginatedPromoCodes_nodes1;
    const TOKEN = (0,es/* useSelector */.v9)((state)=>{
        var _state_auth;
        return state === null || state === void 0 ? void 0 : (_state_auth = state.auth) === null || _state_auth === void 0 ? void 0 : _state_auth.access_token;
    });
    const router = (0,next_router.useRouter)();
    const { redirect  } = router.query;
    const { t  } = (0,useTranslation/* default */.Z)();
    //fetch PromoCode
    const [paginatedPromoCodes, setPaginatedPromoCodes] = (0,react.useState)();
    const [loading, setLoading] = (0,react.useState)();
    //comp pagination
    const [currentPage, setCurrentPage] = (0,react.useState)(0);
    const [pageSize, setPageSize] = (0,react.useState)(5);
    // get all promo code with pagination
    const getPaginatePromoCode = async (skip)=>{
        setLoading(true);
        const { data , error  } = await (0,services/* getPaginatedPromoCodes */.WQ)({
            options: {
                take: pageSize,
                skip: Number(skip) ? Number(skip) * pageSize : 0,
                where: {
                    code: null
                }
            },
            TOKEN
        });
        if (error) {
            console.log("error", error);
            setLoading(false);
        } else {
            setPaginatedPromoCodes(data === null || data === void 0 ? void 0 : data.paginatedPromoCodes);
            setLoading(false);
        }
    };
    (0,react.useEffect)(()=>{
        getPaginatePromoCode(currentPage);
    }, [
        currentPage
    ]);
    //Copy PromoCode function
    const [title, setTitle] = (0,react.useState)("Copy");
    const handleCopy = (code)=>{
        const textToCopy = code;
        navigator.clipboard.writeText(textToCopy).then(()=>{
            console.log(t("Texte copi\xe9 avec succ\xe8s"));
        }).catch((error)=>{
            console.error("Error copying text:", error);
        });
        setTitle("Copied");
        setTimeout(()=>{
            setTitle("Copy");
        }, 400);
    // router.push(`${redirect ? redirect : "/codePromo"}`);
    };
    const endCodeDate = dayjs_min_default()().subtract(1, "day").endOf("day").toISOString();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[1366px] min-h-[100vh] mx-auto pt-[109px] px-[30px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col w-full gap-16 mt-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-3xl font-bold font-MyriadPro uppercase tracking-widest",
                    children: t("fidarri coupons")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-4 mb-24",
                    children: [
                        loading !== null && loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden sm:flex w-full h-full items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spiner/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: paginatedPromoCodes && (paginatedPromoCodes === null || paginatedPromoCodes === void 0 ? void 0 : paginatedPromoCodes.totalCount) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "md:text-lg md:font-semibold lg:text-2xl lg:font-semibold font-MyriadPro",
                                        children: t("Chez Fidarri, nous nous engageons \xe0 offrir \xe0 nos clients les meilleures offres et r\xe9ductions. Restez \xe0 l'\xe9coute pour des promotions incroyables \xe0 venir bient\xf4t!")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 500,
                                        height: 500,
                                        src: "/svg/coponEmp.svg",
                                        alt: "coupon",
                                        className: "mx-auto"
                                    })
                                ]
                            }) : paginatedPromoCodes === null || paginatedPromoCodes === void 0 ? void 0 : (_paginatedPromoCodes_nodes = paginatedPromoCodes.nodes) === null || _paginatedPromoCodes_nodes === void 0 ? void 0 : _paginatedPromoCodes_nodes.map((code, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hidden sm:flex shadow-lg bg-opacity-10 w-full h-[294px] rounded-lg bg-white lg:flex-row items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full flex items-center justify-center mx-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/copon.png",
                                                alt: "copone",
                                                className: "w-[100%] h-[150px] rounded-lg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-auto flex flex-col gap-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "font-bold text-2xl text-[#D76262]",
                                                    children: t("code coupon")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-2xl md:text-[32px] font-bold",
                                                    children: [
                                                        code.discountPercentage ? code.discountPercentage + " %" : code.discount + " DZD",
                                                        " ",
                                                        t("de r\xe9duction avec les coupons fiddari")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "md:text-lg text-base text-[#888888]",
                                                    children: [
                                                        t("Ce code de r\xe9duction expire apr\xe8s"),
                                                        " ",
                                                        code.usageLimit - code.usedTimes,
                                                        " ",
                                                        t("utilisations, plus vite avant la fin de l’offre!")
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "px-10 flex flex-col items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: title,
                                                    arrow: true,
                                                    followCursor: true,
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: ()=>handleCopy(code.code),
                                                        className: "relative cursor-pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/svg/coponCut.svg",
                                                                alt: "cut"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-10 text-sm md:text-[18px] w-full text-center font-MyriadPro font-bold text-secondary",
                                                                children: code.code
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-sm font-semibold",
                                                    children: [
                                                        code.usedTimes,
                                                        " ",
                                                        t("utilis\xe9")
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, index))
                        }),
                        loading !== null && loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sm:hidden w-full h-full flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spiner/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: paginatedPromoCodes && (paginatedPromoCodes === null || paginatedPromoCodes === void 0 ? void 0 : paginatedPromoCodes.totalCount) > 0 && (paginatedPromoCodes === null || paginatedPromoCodes === void 0 ? void 0 : (_paginatedPromoCodes_nodes1 = paginatedPromoCodes.nodes) === null || _paginatedPromoCodes_nodes1 === void 0 ? void 0 : _paginatedPromoCodes_nodes1.map((code, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sm:hidden flex shadow-lg bg-opacity-10 w-full h-fit py-3 rounded-lg bg-white flex-col gap-7 md:flex-row items-center p-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full sm:flex items-center justify-center mr-4 ml-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/copon.png",
                                                alt: "copone",
                                                className: "w-[100%] h-[150px] rounded-lg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-evenly w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-bold text-16 text-[#D76262]",
                                                            children: t("code coupon")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: " flex flex-row items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    onClick: ()=>handleCopy(code.code),
                                                                    className: "relative cursor-pointer",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/svg/coponCut.svg",
                                                                            alt: "cut",
                                                                            width: 70,
                                                                            height: 40
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            id: "code",
                                                                            className: "absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-10 text-[14px] font-MyriadPro font-bold text-secondary",
                                                                            children: code.code
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "text-xs font-semibold",
                                                                    children: [
                                                                        code.usedTimes,
                                                                        " ",
                                                                        t("utilis\xe9")
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-[16px] font-bold",
                                                    children: [
                                                        code.discountPercentage ? code.discountPercentage + " %" : code.discount + " DZD",
                                                        " ",
                                                        t("de r\xe9duction avec les coupons fiddari")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-xs text-[#888888]",
                                                    children: [
                                                        t("Ce code de r\xe9duction expire apr\xe8s"),
                                                        " ",
                                                        code.usageLimit - code.usedTimes,
                                                        " ",
                                                        t("utilisations, plus vite avant la fin de l’offre!")
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, index)))
                        }),
                        (paginatedPromoCodes === null || paginatedPromoCodes === void 0 ? void 0 : paginatedPromoCodes.totalCount) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full flex justify-end mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                count: paginatedPromoCodes === null || paginatedPromoCodes === void 0 ? void 0 : paginatedPromoCodes.totalCount,
                                pagesize: pageSize,
                                setPage: (e)=>{
                                    setCurrentPage(e);
                                },
                                page: Number(currentPage) ? Number(currentPage) : 0,
                                showPages: 3
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var layouts_CodePromoLayout = (CodePromoLayout);

;// CONCATENATED MODULE: ./pages/codePromo.jsx






const CodePromo = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "fidarri coupons",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_CodePromoLayout, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var codePromo = (CodePromo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [819,8823,3428,6078,5306,8571,9774,2888,179], function() { return __webpack_exec__(40778); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);